module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-form"
  }, [_c('joi-form', {
    attrs: {
      "data": _vm.data,
      "schema": _vm.validationSchema,
      "error": _vm.formError
    },
    on: {
      "formdataready": _vm.save
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-4 columns small-centered"
  }, [_c('span', {
    attrs: {
      "data-form-error-callout": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns"
  }, [_c('label', {
    attrs: {
      "error-path": "channels"
    }
  }, [_vm._v("\n          Megfigyelt oldalak:\n        ")]), _vm._v(" "), _c('channel-cards', {
    attrs: {
      "service": _vm.channelsService
    },
    model: {
      value: (_vm.data.channels),
      callback: function($$v) {
        _vm.$set(_vm.data, "channels", $$v)
      },
      expression: "data.channels"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row expanded bottom"
  }, [_c('div', {
    staticClass: "small-4 columns"
  }, [_c('button', {
    staticClass: "button primary trans-uppercase",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button secondary trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Vissza")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bdd6f58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/insights/Settings.vue
// module id = 475
// module chunks = 2